// @flow
import React from 'react';
import styles from './Slider.css';
import classnames from 'classnames';
import IconLabel from '../util/IconLabel';
import { commonMessages } from '../messages/Common';
import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';

type OwnProps = {
  onNextClick: Function,
  onPrevClick: Function,
  canGoBack: boolean,
  canGoForward: boolean,
};

type Props = OwnProps & {
  intl: IntlShape,
};

const SliderControls = ({ onNextClick, onPrevClick, canGoBack, canGoForward, intl }: Props) => (
  <div className={styles.sliderControls}>
    <button
      className={classnames(styles.prevSliderButton, !canGoBack && styles.inactive)}
      onClick={onPrevClick}
      aria-label={intl.formatMessage(commonMessages.previous)}
    >
      <IconLabel name="chevron-left" className={styles.buttonIcon} />
    </button>
    <button
      className={classnames(styles.nextSliderButton, !canGoForward && styles.inactive)}
      onClick={onNextClick}
      aria-label={intl.formatMessage(commonMessages.next)}
    >
      <IconLabel name="chevron-right" className={styles.buttonIcon} />
    </button>
  </div>
);

export default injectIntl(SliderControls);
